import React, { Component } from 'react';
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VSelect from 'react-validation/build/select';
import VButton from 'react-validation/build/button';
import validator from 'validator';
import Countdown360 from 'react-countdown360';
// Requests
import axios from "axios";
import { appConfig } from '../../../../tools/AppConfig';
import Waiting from './../../../waiting';
// Images
import niftLogo from './../../../../../statics/img/nift/nift.png';
import paymobLogo from "./../../../../../statics/img/esaypaisa/paymob.png";
import NiftStatus from './NiftStatus';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import jwt_decode from "jwt-decode";
import './Nift.css';

let resend_setInterval;

class Nift extends Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            // First Screen
            banksArray: [],
            reference: "",
            bank: "",
            cnic: "",
            account_number: "",
            // OTP Screen
            nift_otp: "",
            invalid_otp_times: 1,
            resend: false,
            resend_counter: 30,
            resend_times: 1,
            // Status Screen
            nift_status: "",
            status_message: "",
            redirection_url: "",
            count_down: true,
            //Public
            waiting: true,
            public_error: false,
            public_error_message: "",
            error: false,
            error_message: "",
            // User Data
            user_data: "",
        };
    }
    componentDidMount(){
        this.getBanksArray();
        this.decodePaymentToken();
    }
    
    // decode payment token
    decodePaymentToken = () => {
        // decode from base64 format
        let base64 = base64_decode(this.props.payment_token);
        // decode from jwt format
        let jwt = jwt_decode(base64);
        this.setState({user_data: jwt});
    }

    // Validations
    requiredV = (value) => {
        if(validator.isEmpty(value)){
            return(
                // We can return string or jsx as the 'error' prop for the validated Component
                <div className="alert alert-danger" role="alert">
                    This field is required.
                </div>
            )
        }
    };
    cnicV = (value,props) => {
        if(props.isChanged == true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length != 13){
                    return <div className="alert alert-danger" role="alert">Please enter a valid CNIC.</div>;
                }
            }
        }
    };
    accountNumberV = (value,props) => {
        if(props.isChanged == true){
            if(!!props.id){
                if(!validator.isNumeric(value)){
                    if(this.state.bank == "HMBL" || this.state.bank == "AKBL"){
                        if(!(value.length == 24 && (value[0] == "P" || value[0] == "p") && (value[1] == "K" || value[1] == "k"))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else{
                        return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                    }
                }else{
                    if(this.state.bank == "ABLBank"){
                        if(!(value.length == 16 && (value[0] == 0 && value[1] == 0 && (value[2] == 1 || value[2] == 2)))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "HMBL"){
                        if(!((value.length == 19 || value.length == 20) && value[0] == 6)){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "BAFL"){
                        if(!(value.length == 14 && (value[4] == 1 || value[4] == 5))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "BOPBank"){
                        if(!(value.length == 16 && (value[0] == 4 || value[0] == 5 || value[0] == 6 || value[0] == 8))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "MCBI"){
                        if(!(value.length == 16 && (value[0] == 1 && value[1] == 0))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "SAMB"){
                        if(!(value.length == 10 && ((value[0] == 2 && value[1] == 0) || (value[0] == 6 && value[1] == 4) || (value[0] == 6 && value[1] == 5)))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "BOKP"){
                        if(!((value.length == 14 || value.length == 16) && (value[0] == 0 || value[0] == 1))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "FABL"){
                        if(!((value.length == 14 || value.length == 16) && (value[0] == 0 || value[0] == 3 || value[0] == 8))){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "AKBL"){
                        if(value.length != 13){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else if(this.state.bank == "BKIP"){
                        if(value.length != 15){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }else{
                        if(value.length != 16){
                            return <div className="alert alert-danger" role="alert">Please enter a valid account number.</div>;
                        }
                    }     
                }
            }
        }
    };
    otpV = (value,props) => {
        if(props.isChanged == true){
            if(!!props.id){
                if(!validator.isNumeric(value) || value.length < 4 || value.length > 6){
                    return <div className="alert alert-danger" role="alert"> Please enter a valid OTP.</div>;
                }
            }
        }
    };

    // 1st Request >> Get Banks Array
    getBanksArray = () => {
        let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        let data = {
            "source": {
                "identifier": "AGGREGATOR",
                "subtype": "NIFT"
            },
            "payment_token": this.props.payment_token
        }
        let jsonData = JSON.stringify(data);
        axios.post(
            url,
            jsonData,
            config
        )
        .then((resp)=>{
            this.setState({waiting: false, public_error: false, public_error_message: "", banksArray: resp.data.data.bankCode, reference: resp.data.data.ref, trnx_id: resp.data.id});
        })
        .catch((err)=>{
            if(err && err.response && err.response.statusText){
                this.setState({waiting: false, public_error: true, public_error_message: err.response.statusText});
            }else{
                this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
            }
        });
    }

    // 2nd Request >> Cancel Trnx
    cancelTrnx = (message) => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/nift_otp/cancel_trx';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "message": message,
                "ref": this.state.reference,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                // fail
                this.setState({waiting: false, public_error: false, public_error_message: "", nift_status: "fail", redirection_url: resp.data.redirection_url, status_message: message});
            })
            .catch((err)=>{
                if(err && err.response && err.response.data && err.response.data.error){
                    this.setState({waiting: false, public_error: true, public_error_message: err.response.data.error});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong! please try again."});
                }
            });
        });
    }

    // 3rd Request >> Send || Resend OTP
    sendOTP = (type) => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/nift_otp/pay_otp';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "pp_BankID": this.state.bank,
                "pp_CNIC": this.state.cnic,
                "pp_AccountNo": this.state.account_number,
                "ref": this.state.reference,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                if(type == "send"){
                    this.setState({waiting: false, error: false, error_message: "", step: 2}, () => {
                        this.start_resend_counter();
                    });
                }else{
                    // Max Trials for Resend OTP
                    if(this.state.resend_times !== 3){
                        this.setState({waiting: false, error: false, error_message: "", step: 2, nift_otp: ""}, () => {
                            this.start_resend_counter();
                        });
                    }else{
                        this.cancelTrnx("Max resend otp trials.");
                    }
                    // Increase Trials for Resend OTP
                    this.setState({resend_times: this.state.resend_times + 1});
                }
            })
            .catch((err)=>{
                if(err && err.response && err.response.data && err.response.data.pp_ResponseMessage){
                    this.setState({waiting: false, error: true, error_message: err.response.data.pp_ResponseMessage});
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong! please try again."});
                }
            });
        });
    }

    // 4th Request >> Confirm OTP
    confirmOTP = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/nift_otp/otp_confirm';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "pp_OTP": this.state.nift_otp,
                "attempt": this.state.invalid_otp_times,
                "ref": this.state.reference,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                if(resp.data.success == "true" && resp.data.pending == "false"){
                    // success
                    this.setState({waiting: false, error: false, error_message: "", nift_status: "success", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success == "false" && resp.data.pending == "true"){
                    // pending
                    this.setState({waiting: false, error: false, error_message: "", nift_status: "pending", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success == "false" && resp.data.pending == "false"){
                    // fail
                    this.setState({waiting: false, error: false, error_message: "", nift_status: "fail", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }
            })
            .catch((err)=>{
                // OTP Timeout
                if(err && err.response && err.response.data && err.response.data.error == "Failed to pay transaction"){
                    this.setState({waiting: false, step: 3});
                }else{
                    // Max Trials for Invalid OTP
                    if(this.state.invalid_otp_times !== 3){
                        this.setState({waiting:false});
                        if(err && err.response && err.response.status == 500){
                            this.setState({error: true, error_message: err.response.statusText});
                        }else{
                            if(err && err.response && err.response.data && err.response.data.message){
                                this.setState({error: true, error_message: err.response.data.message});
                            }else{
                                this.setState({error: true, error_message: "Something went wrong please try again."});
                            }
                        }
                    }else{
                        this.cancelTrnx("Something went wrong.");
                    }
                    // Increase Trials for Invalid OTP
                    this.setState({invalid_otp_times: this.state.invalid_otp_times + 1});
                }
            });
        });
    }

    // 5th Request >> Inquiry
    handleInquiry = () =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/transactions/transaction_inquiry';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "transaction_id": this.state.trnx_id,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                // success
                if(resp.data.success == "true" && resp.data.pending == "false" && resp.data.redirection_url){
                    this.setState({waiting: false, public_error: false, public_error_message: "", nift_status: "success", redirection_url: resp.data.redirection_url});
                // pending
                }else if(resp.data.success == "false" && resp.data.pending == "true" && resp.data.redirection_url){
                    this.setState({waiting: false, public_error: false, public_error_message: "", nift_status: "pending", redirection_url: resp.data.redirection_url});
                // fail
                }else if(resp.data.success == "false" && resp.data.pending == "false" && resp.data.redirection_url){
                    this.setState({waiting: false, public_error: false, public_error_message: "", nift_status: "fail", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }
            })
            .catch((err)=>{
                this.setState({waiting: false, count_down: false, public_error: true, public_error_message: "Something went wrong."});
            });
        });
    }

    // Resend OTP Counter 
    start_resend_counter = () => {
        this.setState({nift_otp: "", resend: true});
        clearInterval(resend_setInterval);
        resend_setInterval = setInterval(()=>this.resend_counter_calc(), 1000)
    }
    resend_counter_calc = () => {
        if(this.state.resend_counter > 0){
            this.setState({resend_counter: this.state.resend_counter - 1});
        }else{
            clearInterval(resend_setInterval);
            this.setState({resend_counter: 30, resend: false});
        }
    }

    // Render Steps
    renderStep1 = () => (
        <div className="nift_content">
            <VForm onSubmit={()=>this.sendOTP("send")}>
                <div className="nift_input">
                    <label>Bank</label>
                    <VSelect 
                        type="select" 
                        name="bank"
                        id="bank"
                        value={this.state.bank}
                        onChange={(e)=>this.setState({bank: e.target.value})}
                        validations={[this.requiredV]} 
                    >
                        <option value="" disabled>Select from list</option>
                        {this.state.banksArray.map((ele)=>(
                            <option key={ele.index} value={ele.bankCode}>{ele.name}</option>
                        ))}
                    </VSelect>
                </div>
                <div className="nift_input">
                    <label>CNIC</label>
                    <VInput 
                        type="text"
                        name="cnic"
                        id="cnic"
                        value={this.state.cnic}
                        onChange={(e)=>this.setState({cnic: e.target.value})}
                        validations={[this.requiredV, this.cnicV]} 
                    />
                </div>
                <div className="nift_input">
                    <label>Account number</label>
                    <VInput 
                        type="text"
                        name="account_number"
                        id="account_number"
                        value={this.state.account_number}
                        onChange={(e)=>this.setState({account_number: e.target.value})}
                        validations={[this.requiredV, this.accountNumberV]}
                    />
                </div>
                <div className="bank_notes">
                    {this.state.bank == "ABLBank" ?
                        <>
                            <p>Please ensure that your Account is Activated to use this service, Kindly Call ABL H/L 021-111-225-225 to activate your local e-commerce service.</p>
                            <p>Please enter your 16-digit account number (without branch code).</p>
                        </>
                    :
                    this.state.bank == "HMBL" ?
                        <p>Please enter your 19 or 20 digit account number or 24 Alphanumeric IBAN number.</p>
                    :
                    this.state.bank == "BAFL" ?
                        <p>Please enter your 14-digit account number.</p>
                    :
                    this.state.bank == "BOPBank" ?
                        <>
                            <p>Please ensure your account is activated to use this service. Kindly Call BOP H/L 042-111-267-200 to activate your e-commerce service.</p>
                            <p>Please enter your 16-digit account number.</p>
                        </>
                    :
                    this.state.bank == "MCBI" ?
                        <>
                            <p>Please ensure your account is activated to use this service. Kindly Call MIB H/L 042-111-222-642 to activate your e-commerce service.</p>
                            <p>Please enter your 16 digit account number.</p>
                        </>
                    :
                    this.state.bank == "SAMB" ?
                        <p>Please enter your 10-digit account number.</p>
                    :
                    this.state.bank == "BOKP" ?
                        <p>Please enter your 14-digit or 16-digit account number.</p>
                    :
                    this.state.bank == "FABL" ?
                        <p>Please enter your 14-digit or 16-digit account number.</p>
                    :
                    this.state.bank == "AKBL" ?
                        <p>Please enter 13 digit Account number or 24 Alpha-numeric IBAN.</p>
                    :
                    this.state.bank == "BKIP" ?
                        <p>Please enter your 15-digit account number.</p>
                    :
                        null
                    }
                </div>
                {this.state.error &&
                    <div className="nift_error">
                        {this.state.error_message}
                    </div>
                }
                <VButton>Proceed</VButton>
            </VForm>
        </div>
    )
    renderStep2 = () => (
        <div className="nift_content otp_screen text-center">
            <VForm onSubmit={()=>this.confirmOTP()}>
                <h1>Verification</h1>
                <p>Please enter the OTP code sent on your registered Mobile number.</p>
                <div className="nift_input">
                    <VInput 
                        type="text"
                        name="nift_otp"
                        id="nift_otp"
                        maxlength="6"
                        value={this.state.nift_otp}
                        onChange={(e)=>this.setState({nift_otp: e.target.value})}
                        validations={[this.requiredV, this.otpV]}
                    />
                </div>
                <div className="resend_otp">
                    <p>
                        Didn’t receive OTP?
                        {this.state.resend?
                            <span>Send again in<span>{this.state.resend_counter}</span> sec.</span>
                        :
                            <span className="send_again" onClick={()=>this.sendOTP("resend")}>Send again</span>
                        }
                    </p>
                </div>
                {this.state.error &&
                    <div className="nift_error">
                        {this.state.error_message}
                    </div>
                }
                <VButton>Confirm</VButton>
            </VForm>
        </div>
    )
    renderTimeout = () => (
        <div className="timeout_div">
            <p>Transaction not yet confirmed by NIFT, please wait.</p>
            <Countdown360
                seconds={35}
                borderFillColor="#E8E7E7"
                borderUnfillColor="#d91f2d"
                borderWidth="3"
                fontSize="30"
                fontWeight="normal"
                clockwise
                width="158"
                smooth
                onComplete={()=>this.handleInquiry()}
            />
        </div>
    )

    render() {
        return (
            <div className={`nift_page ${this.state.user_data.user_id === 2886 ? "white_back" : ""}`}>
                {this.state.nift_status == "" ?
                    <div className="nift_container">
                        <span onClick={()=>this.cancelTrnx("Transaction abandoned.")}>X <span>Cancel</span></span>
                        <div className="nift_header">
                            <img src={niftLogo} />
                        </div>
                        {this.state.waiting ?
                            <Waiting height='400px' />
                        :
                            this.state.public_error ?
                                <div className="nift_error public_error">
                                    {this.state.public_error_message}
                                </div>
                            :
                                this.state.step == 1 ?
                                    this.renderStep1()
                                : this.state.step == 2 ?
                                    this.renderStep2()
                                :
                                    this.renderTimeout()
                        }
                        <div className="nift_footer">
                            <span>Powered by</span>
                            <img src={paymobLogo} className="paymob" />
                        </div>
                    </div>
                :
                    <div className="nift_container">
                        <NiftStatus
                            nift_status={this.state.nift_status}
                            status_message={this.state.status_message}
                            redirection_url={this.state.redirection_url}
                        />
                        <div className="nift_footer">
                            <span>Powered by</span>
                            <img src={paymobLogo} className="paymob" />
                        </div>
                    </div>
                }
            </div>
        )
    }
}
export default Nift;